import Referrals from "../../../components/user/referrals/Referrals";
import {defer} from "react-router-dom";
import {ReferralService} from "../../../service/ReferralService";
import {ReferralData} from "../../../model/user/referrals/Referrals";
import MainDesign from "../../MainDesign";

type LoaderData = {
    referralData: Promise<ReferralData>;
};

export function loader() {
    return defer({
        referralData: ReferralService.getReferralData()
    });
}

export default function ReferralsPage() {
    return (
        <MainDesign containerStyles="container py-md-16 py-10" useGradientBackground addOrb>
            <Referrals/>
        </MainDesign>
    );
}